import { Effect, Layer, Queue, Result, Scope } from "effect";
import { recordingFullscreenFailure, type RecordingFullscreenObservation } from "./fullscreen-model.ts";
import { RecordingFullscreenIo } from "./fullscreen-service.ts";

export const RecordingFullscreenIoLive = Layer.succeed(RecordingFullscreenIo, RecordingFullscreenIo.of({ events: admission => Effect.gen(function* () {
  const owner = yield* Scope.Scope;
  if (admission.state._tag === "Closed" || owner.state._tag === "Closed") return yield* Effect.interrupt;
  const queue = yield* Effect.acquireRelease(Queue.unbounded<RecordingFullscreenObservation>(), Queue.shutdown);
  const page = yield* Effect.try({ try: () => typeof document === "undefined" ? undefined : document, catch: recordingFullscreenFailure });
  const receive = () => {
    if (admission.state._tag === "Closed" || owner.state._tag === "Closed") return;
    const result = Result.try(() => Boolean(page?.fullscreenElement));
    Queue.offerUnsafe(queue, Result.isFailure(result) ? { _tag: "Failed", failure: recordingFullscreenFailure(result.failure) } : { _tag: "Active", value: result.success });
  };
  if (page) {
    yield* Effect.addFinalizer(() => Effect.try({ try: () => page.removeEventListener("fullscreenchange", receive), catch: recordingFullscreenFailure }).pipe(Effect.orDie));
    yield* Effect.try({ try: () => page.addEventListener("fullscreenchange", receive), catch: recordingFullscreenFailure });
  }
  yield* Effect.sync(receive);
  return queue;
}) }));
